/**
 * The KYC module's routes, owned by the feature. Same shape as `src/features/audit/routes.tsx`.
 *
 * `/kyc` is registered but unreachable by navigation: it is absent from the thirteen `NAV_ITEMS`
 * in `src/components/AdminLayout.tsx`, so only a typed URL lands here. That was true before this
 * migration and is left true by it — adding a sidebar entry would put a screen that cannot work in
 * front of operators (F-077).
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const KycVerificationPage = lazy(() => import('./KycVerificationPage'));

export const kycRoutes: RouteObject[] = [{ path: 'kyc', element: <KycVerificationPage /> }];
